import { render, staticRenderFns } from "./personnelTransfer.vue?vue&type=template&id=c1e6ec3a&scoped=true"
import script from "./personnelTransfer.vue?vue&type=script&lang=js"
export * from "./personnelTransfer.vue?vue&type=script&lang=js"
import style0 from "./personnelTransfer.vue?vue&type=style&index=0&id=c1e6ec3a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1e6ec3a",
  null
  
)

export default component.exports